import axios from 'axios';

export const httpClient = axios.create({

    

       baseURL: 'http://148.72.245.102:8975/', 






});

export default httpClient;

